import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import BizConfigAdminListView    from "./BizConfigAdminListView";
import BizConfigAdminDetailsView from "./BizConfigAdminDetailsView";
import BizConfigAdminNewView     from "./BizConfigAdminNewView";


const BizConfigAdmin = () => {

  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const [uiMode,     setUIMode]     = useState('LIST');
  const [objDetails, setObjDetails] = useState({});
  const [pageState,  setPageState]  = useState({
                                        searchTerms: null,
                                        sortCol:     null,
                                        sortDir:     null,
                                        perPage:     25,
                                        currPage:    1});

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["SystemAdminFullAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <BizConfigAdminListView    pageState={pageState} onUIMode={setUIMode}
                                                           onSetPageState={setPageState} onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <BizConfigAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <BizConfigAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default BizConfigAdmin;
